import type { ClassValue } from "svelte/elements";

/** Provides autocompletion for tailwindcss */
export function tw(...classes: Extract<ClassValue, unknown[]>): ClassValue {
	return classes;
}
